import React, { useEffect, useState } from 'react';
import { Card } from '../components';
import { Header, Stat, Message, Button } from 'react-frontier';
import { useBusiness, useTitle } from '../Hooks';
import { Payout } from '../Classes';
import { useParams, Link } from 'react-router-dom';
import { addCommas } from '@tempu/components/Util';
import BusinessAccess from '../BusinessAccess';
import API from '../API';
import classNames from 'classnames';
import moment from 'moment';

var BusinessPayouts = ()=>{
	var { setTitle, setAction } = useTitle();
	var params = useParams<{ id: string }>();
	var business_id = parseInt(params?.id);
	var { hasAccess } = useBusiness(business_id);
	var [loadError, setLoadError] = useState<string>(null);
	var [payouts, setPayouts] = useState<Payout[]>(null);

	useEffect(()=>{
		setTitle('Liquidaciones');

		if(!params || !business_id || Number.isNaN(business_id)) return;
		if(!hasAccess(BusinessAccess.ACCOUNTING.VIEW_PAYOUTS)) return;

		if(hasAccess(BusinessAccess.ACCOUNTING.CREATE_PAYOUTS)){
			setAction(
				<Button text='Nueva liquidación' iconName='plus-circle' color='black' as={Link} to={`/business/${business_id}/postings`}/>
			);
		}

		API.getBusinessPayouts(business_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPayouts(res.data);
		}).catch(e=>{
			return setLoadError('Hubo un error inesperado cargando las liquidaciones. (LCL-1)');
		});
		
	}, []);

	if(!hasAccess(BusinessAccess.ACCOUNTING.VIEW_PAYOUTS)){
		return <Header text='Sin acceso' subtext='No tienes acceso a esta página' />
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!payouts){
		return <Header loading text='Cargando datos' />;
	}

	var debtTotal = payouts?.reduce((s, p) => { return s + p.total_pending; }, 0);

	return <div className="tp business-payouts-screen">
		<Stat.Group>
			<Stat value={'$'+addCommas(debtTotal)} label={'Pendiente de pago'} />
			<Stat value={(
				<i className='infinity icon' />
			)} label={'Saldo a favor'} />
		</Stat.Group>
		{payouts.length>0 && (
			<Header text='Historial de liquidaciones' centered={false} style={{ marginTop: 15 }} size='small' />
		)}
		{payouts.length !== 0 ? (
			payouts.map(p=>(
				<Card className='payout' key={`LQPLH-${p.payout_id}`} as={Link} to={`/business/${business_id}/posting/${p.posting_id}/payout/${p.payout_id}`}>
					<div className="left">
						<div className="meta">Liquidación: {p.payout_id}</div>
						<div className="value">{p.posting_name}</div>
						<div className="meta id">{moment.unix(p.date_created).format('DD/MMM/YY HH:mm')}</div>
						<div className="value">{p.employees} empleados</div>
					</div>
					<div className='right'>
						<div className="amount">${addCommas(p.total_pending + p.total_paid)}</div>
						{p.total_paid > 0 && !p.paid && <div className="second">Pagado: ${addCommas(p.total_paid)}</div>}
						<div style={{ marginTop: 5 }} className={classNames("fr label", {
							green: p.paid && !p.cancelled,
							yellow: !p.paid && !p.cancelled,
							red: p.cancelled
						})}>
							{p.cancelled ? 'Cancelada' : p.paid ? 'Pagada' : 'No Pagada'}
						</div>
					</div>
				</Card>
			))
		) : (
			<Header text={'Sin liquidaciones'} subtext={'El negocio no tiene liquidaciones realizadas'} iconName='money-bill-wave' style={{ marginTop: 15 }} />
		)}
	</div>
}

export default BusinessPayouts;